<template>
    <div>
        <table v-if="values.ci !== undefined && values.co !== undefined">
            <tr>
                <th> {{$t("month")}} </th>
                <th> {{$t("cash-in")}} </th>
                <th> {{$t("cash-out")}} </th>
                <th align="right"> {{$t("ratio")}} </th>
            </tr>
            <tr v-for="(month, index) of months" :key="month">
                <td> {{ month }} </td>
                <td> {{f(values.ci[index])}} </td>
                <td> {{f(values.co[index])}} </td>
                <td align="right"> {{fratio(values.ratio[index])}} </td>
            </tr>
        </table>
    </div>
</template>
<script>

import * as d3 from 'd3-format';

export default {
    name: 'jc-agent',
    props: {
        values: Object,
        months: Array,
    },
    created() {
        this.f = d3.format(',.0f');
        this.fratio = d3.format(',.3r');
    }
}
</script>

<style lang="scss" scoped>
div {
    padding: 0.3rem;
    margin: 0 auto;
    width: 25rem;

    table {
        margin: 0 auto;
        width: 90%;
        border-collapse: collapse;

        tr:not(:first-child) {
            border-top: 1px #ddd solid;
        }
    }
}
</style>
